<comment>
グレードリスト
カルーセル部は別コンポーネントに要素をスロットで渡す
</comment>

<template>
  <div @mousedown.stop="" v-if="showGradeList" class="gradeListBase">
    <div class="gradeListBase__inner">
      <div class="gradeList">
        <div class="gradeList__slider">
          <gradeSlider ref="gradeSlider" @pageStateChange='sliderStateChange'>
            <div class="gradeList__slider-cell" v-for="grade in gradeList" :key="grade.id">
              <div class="gradeList__thumb-parent" :class="{active:currentGradeId===grade.id}">
                <button class="gradeList__thumb-btn" @click="changeGrade(grade.id)" :style="{backgroundImage:'url(../../assets/materials/thumbnails/'+grade.thumbnail+'.png)'}"></button>
              </div>
            </div>
          </gradeSlider>
        </div>
        <div v-if="sliderEnabled" class="gradeList__slider-ctrl">
          <button :disabled="sliderReachEnd" class="gradeList__slider-next" @click="$refs.gradeSlider.next()"></button>
          <button :disabled="sliderReachStart" class="gradeList__slider-prev" @click="$refs.gradeSlider.prev()"></button>
        </div>
        <div class="gradeList__close">
          <button class="gradeList__close-btn" @click="displayGradeList()"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import gradeSlider from './gradeSlider'

export default {
  name: 'gradeList',
  components: { gradeSlider },
  data: function() {
    return {
      sliderReachStart: true,
      sliderReachEnd: true,
      sliderEnabled: false
    };
  },
  computed: {
    ...mapState([
      'currentGradeId',
      'showGradeList',
      'gradeList',
    ]),
  },
  methods: {
    ...mapActions([
      'changeGrade',
      'displayGradeList'
    ]),
    sliderStateChange(reachStart,reachEnd){
      if(!this.sliderEnabled && (!reachStart || !reachEnd)){
        this.sliderEnabled = true;
      }
      this.sliderReachStart = reachStart;
      this.sliderReachEnd = reachEnd;
    }
  },
}
</script>

<style lang="scss" scoped>
.gradeListBase{
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  box-sizing: border-box;
  pointer-events: none;
  &__inner{
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    > *{
      pointer-events: auto;
    }
    @include size_s{
      padding: 0 15px;
    }
  }
}
.gradeList{
  height: 170px;
  background: #FFF;
  box-shadow: 0 1px 0 0 rgba(0,0,0,0.05);
  display: flex;
  width: 100%;
  @include size_s(){
    height: 128px;
  }
  
  &__slider{
    width: 1px;
    flex-grow: 1;
    padding: 11px 0;
    @include size_s(){
      padding: 8px 0;
    }
  }
  &__slider-ctrl{
    width: 39px;
    min-width: 39px;
    max-width: 39px;
    border-left: 1px #dcdcdc solid;
    @include size_s{
      width: 28px;
      min-width: 28px;
      max-width: 28px; 
    }
  }
  &__close-btn{
    appearance: none;
    border: none;
    width: 100%;
    height: 100%;
    display: block;
    cursor: pointer;
    background: url(../assets/image/btn_menu_close.png) no-repeat #f2f0eb;
    background-size: cover;
  }
  &__close{
    width: 51px;
    min-width: 51px;
    max-width: 51px; 
    border-left: 1px #e0ded7 solid;
    @include size_s{
      width: 39px;
      min-width: 39px;
      max-width: 39px; 
    }
  }

  &__slider-cell{
    padding-left: 7px;
    @include size_s(){
        padding-left: 5px;
      }
    &:first-child{
      padding-left: 11px;
      @include size_s(){
        padding-left: 7px;
      }
    }
  }

  &__slider-next,
  &__slider-prev{
    width: 100%;
    height: 50%;
    background:no-repeat 0 0;
    background-size: cover;
    border: 0;
    display: block;
    cursor: pointer;
    &:disabled{
      cursor: default;
      background-position: right top;
    }
  }
  &__slider-next{background-image: url(../assets/image/slide_nav_right.png);}
  &__slider-prev{background-image: url(../assets/image/slide_nav_left.png);}

  &__thumb-parent{
    width: 106px;
    display: block;
    border: solid 3px rgba(255,255,255,0);
    padding: 1px;
    line-height: 0;
    &.active{
      border-color: #D62C2C;
    }
    @include size_s(){
      width: 81px;
      border-width: 2px;
      padding: 0;
    }
  }
  &__thumb-btn{
    width: 106px;
    height: 140px;
    cursor: pointer;
    border: none;
    appearance: none;
    background-size: contain;
    background-repeat: no-repeat;
    
    @include size_s(){
      width: 80px;
      height: 107px;
      background-position: 1px 1px;
    }
  }
}
</style>